import React from 'react'

import { Game } from '../../../Game'
import { Props } from '../GamesGrid'
import { useGamesFromSlugs } from '../hooks'
import { MobileGamesGridBox } from './styles'

export function MobileGamesGrid({ rows, gameSlugs }: Props) {
  const gamesFromSlugs = useGamesFromSlugs(gameSlugs)

  return (
    <MobileGamesGridBox rows={rows}>
      {gamesFromSlugs.map((game) => (
        <Game
          key={game.slug}
          game={game}
        />
      ))}
    </MobileGamesGridBox>
  )
}
